module.exports = __webpack_public_path__ + "img/certidao.ef25653e.png";